// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Loader_spinnerContainer__2jN3k","loadingSpinner":"Loader_loadingSpinner__5YeLv","spinner":"Loader_spinner__Y2Yp-"};